import React from 'react';

/**
 * Static SVG stand-in for the "Subtitle" block on its palette card: a single
 * heading with no body. Wireframe style, matching {@link TextSectionPreviewGraphic}.
 */

const CARD_X = 30;
const CARD_Y = 30;
const CARD_W = 1120;
const CARD_H = 120;
const PAD = 28;
const VIEW_H = CARD_Y + CARD_H + 16;

export default function SubtitlePreviewGraphic() {
  return (
    <svg
      viewBox={`0 0 1180 ${VIEW_H}`}
      width="100%"
      role="img"
      aria-label="Subtitle block: a single heading with no body"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <rect
        x={CARD_X}
        y={CARD_Y}
        width={CARD_W}
        height={CARD_H}
        rx="20"
        fill="#F1F2EF"
        stroke="#E4E4E0"
      />
      <text
        x={CARD_X + PAD}
        y={CARD_Y + CARD_H / 2 + 14}
        fontFamily="Manrope, system-ui, -apple-system, sans-serif"
        fontSize="40"
        fontWeight="700"
        fill="#20423A"
      >
        Subtitle
      </text>
    </svg>
  );
}
